module.exports = __webpack_public_path__ + "img/welding-13.945d3cdb.jpg";